"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".AdWritter textarea{resize:none}.AdWritter .mat-progress-spinner circle,.AdWritter .mat-spinner circle{stroke:#f92c7a}.AdWritter .premiumAdTokenPayment .securityPaymentInformation{color:red}.AdWritter .mat-checkbox-layout{white-space:normal!important}.AdWritter .mat-checkbox-inner-container{position:absolute!important;top:5px!important}.AdWritter .mat-checkbox-label{margin-left:20px!important;font-size:12px!important}"];
exports.styles = styles;
